import styled, { css } from 'styled-components'
import { Avatar } from 'ui'
import { decimalToHexStr } from 'utils/numbers'

export const Container = styled.div`
  position: relative;
  cursor: pointer;
`

export const AvatarBtn = styled(Avatar)`
  ${({ theme, $isCreators, $isActive}) => {
    const borderActive = $isCreators
      ? theme.old.colors.gray[800]
      : theme.old.colors.gray[250] + decimalToHexStr(.6)

    const borderHover = $isCreators
      ? theme.old.colors.gray[900]
      : theme.old.colors.gray[250] + decimalToHexStr(.4)

    return css`
      border: 2px solid ${$isActive ? borderActive : 'transparent'};
    
      :hover {
        border: 2px solid ${$isActive ? borderActive : borderHover};
      }
    `
  }}
`

export const NavDropdown = styled.nav`
  position: absolute;
  background-color: ${({ theme, $isCreators }) => $isCreators
    ? theme.old.colors.white
    : '#18181B'
  };
  border: ${({ $isCreators }) => $isCreators
    ? 'none'
    : '2px solid rgba(255, 255, 255, 0.15)'
  };

  min-width: 260px;
  width: 260px;

  border-radius: 8px;
  display: flex;
  flex-direction: column;

  transition: ${({theme}) => theme.old.transition.default};
  opacity: ${({$isOpen}) => $isOpen ? 1 : 0};
  visibility: ${({$isOpen}) => $isOpen ? 'show' : 'hidden'};
  transform: ${({ $isOpen }) => $isOpen ? 'translateY(0)' : 'translateY(-10px)'};
  box-shadow: 0 4px 16px -8px rgba(0, 0, 0, .3);

  z-index: 20000;
  top: 128%;
  right: 0;

  ${({ theme, $isCreators }) => {
    if (!$isCreators) return

    return css`
      ${theme.old.breakpoints.isTab} {
        right: 0px;

        &::before {
          right: 10px;
        }
      }
    `
  }}
`
